/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = [".form-alert[_ngcontent-%COMP%]{margin-top:.5rem;max-width:15rem}"];
export { styles as styles };

